define(["exports", "webidl2", "./dfn-finder", "./utils", "text!../../assets/webidl.css", "hyperhtml", "./dfn-map"], function (_exports, webidl2, _dfnFinder, _utils, _webidl2, _hyperhtml, _dfnMap) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  webidl2 = _interopRequireWildcard(webidl2);
  _webidl2 = _interopRequireDefault(_webidl2);
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _templateObject16() {
    const data = _taggedTemplateLiteral(["", ""]);

    _templateObject16 = function _templateObject16() {
      return data;
    };

    return data;
  }

  function _templateObject15() {
    const data = _taggedTemplateLiteral(["<a\n    data-idl=\"", "\"\n    data-link-type=\"", "\"\n    data-title=\"", "\"\n    data-xref-type=\"", "\"\n    >", "</a>"]);

    _templateObject15 = function _templateObject15() {
      return data;
    };

    return data;
  }

  function _templateObject14() {
    const data = _taggedTemplateLiteral(["<dfn data-export data-dfn-type=\"", "\">", "</dfn>"]);

    _templateObject14 = function _templateObject14() {
      return data;
    };

    return data;
  }

  function _templateObject13() {
    const data = _taggedTemplateLiteral(["<a\n     data-link-type=\"dfn\"\n     data-lt=\"default toJSON operation\">", "</a>"]);

    _templateObject13 = function _templateObject13() {
      return data;
    };

    return data;
  }

  function _templateObject12() {
    const data = _taggedTemplateLiteral(["<a\n      data-link-for=\"", "\"\n      data-link-type=\"", "\"\n      href=\"", "\"\n      class=\"internalDFN\"\n      ><code>", "</code></a>"]);

    _templateObject12 = function _templateObject12() {
      return data;
    };

    return data;
  }

  function _templateObject11() {
    const data = _taggedTemplateLiteral(["<a data-xref-type=\"extended-attribute\">", "</a>"]);

    _templateObject11 = function _templateObject11() {
      return data;
    };

    return data;
  }

  function _templateObject10() {
    const data = _taggedTemplateLiteral(["<span class=\"extAttr\">", "</span>"]);

    _templateObject10 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9() {
    const data = _taggedTemplateLiteral(["<span class='", "' id='", "' data-idl data-title='", "'>", "</span>"]);

    _templateObject9 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["<span class='", "'>", "</span>"]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["<span class=\"idlSuperclass\">", "</span>"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["<span class=\"idlType\">", "</span>"]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["<span class=\"idlParamName\">", "</span>"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["<a\n      data-xref-type=\"", "\" data-cite=\"", "\" data-lt=\"", "\">", "</a>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["<a data-xref-type=\"dfn\" data-cite=\"WebIDL\">", "</a>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["<a data-xref-type=\"interface\" data-cite=\"WebIDL\">", "</a>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<span class='idlSectionComment'>", "</span>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/webidl";
  _exports.name = name;
  const operationNames = {};
  const idlPartials = {};
  const templates = {
    wrap(items) {
      return items.reduce(_utils.flatten, []).filter(x => x !== "").map(x => typeof x === "string" ? new Text(x) : x);
    },

    trivia(t) {
      if (!t.trim()) {
        return t;
      }

      return (0, _hyperhtml.default)(_templateObject(), t);
    },

    generic(keyword) {
      // Shepherd classifies "interfaces" as starting with capital letters,
      // like Promise, FrozenArray, etc.
      return /^[A-Z]/.test(keyword) ? (0, _hyperhtml.default)(_templateObject2(), keyword) : // Other keywords like sequence, maplike, etc...
      (0, _hyperhtml.default)(_templateObject3(), keyword);
    },

    reference(wrapped, unescaped, context) {
      if (context.type === "extended-attribute" && context.name !== "Exposed") {
        return wrapped;
      }

      let type = "_IDL_";
      let cite = null;
      let lt;

      switch (unescaped) {
        case "Window":
          type = "interface";
          cite = "HTML";
          break;

        case "object":
          type = "interface";
          cite = "WebIDL";
          break;

        default:
          {
            const isWorkerType = unescaped.includes("Worker");

            if (isWorkerType && context.type === "extended-attribute") {
              lt = "".concat(unescaped, "GlobalScope");
              type = "interface";
              cite = ["Worker", "DedicatedWorker", "SharedWorker"].includes(unescaped) ? "HTML" : null;
            }
          }
      }

      return (0, _hyperhtml.default)(_templateObject4(), type, cite, lt, wrapped);
    },

    name(escaped, {
      data,
      parent
    }) {
      if (data.idlType && data.idlType.type === "argument-type") {
        return (0, _hyperhtml.default)(_templateObject5(), escaped);
      }

      const idlLink = defineIdlName(escaped, data, parent);

      if (data.type !== "enum-value") {
        const className = parent ? "idlName" : "idlID";
        idlLink.classList.add(className);
      }

      return idlLink;
    },

    nameless(escaped, {
      data,
      parent
    }) {
      switch (data.type) {
        case "constructor":
          return defineIdlName(escaped, data, parent);

        default:
          return escaped;
      }
    },

    type(contents) {
      return (0, _hyperhtml.default)(_templateObject6(), contents);
    },

    inheritance(contents) {
      return (0, _hyperhtml.default)(_templateObject7(), contents);
    },

    definition(contents, {
      data,
      parent
    }) {
      const className = getIdlDefinitionClassName(data);

      switch (data.type) {
        case "includes":
        case "enum-value":
          return (0, _hyperhtml.default)(_templateObject8(), className, contents);
      }

      const parentName = parent ? parent.name : "";
      const {
        name,
        idlId
      } = getNameAndId(data, parentName);
      return (0, _hyperhtml.default)(_templateObject9(), className, idlId, name, contents);
    },

    extendedAttribute(contents) {
      const result = (0, _hyperhtml.default)(_templateObject10(), contents);
      return result;
    },

    extendedAttributeReference(name) {
      return (0, _hyperhtml.default)(_templateObject11(), name);
    }

  };
  /**
   * Returns a link to existing <dfn> or creates one if doesn’t exists.
   */

  function defineIdlName(escaped, data, parent) {
    const parentName = parent ? parent.name : "";
    const {
      name
    } = getNameAndId(data, parentName);
    const dfn = (0, _dfnFinder.findDfn)(data, name, {
      parent: parentName
    });
    const linkType = getDfnType(data.type);

    if (dfn) {
      if (!data.partial) {
        dfn.dataset.export = "";
        dfn.dataset.dfnType = linkType;
      }

      (0, _dfnFinder.decorateDfn)(dfn, data, parentName, name);
      const href = "#".concat(dfn.id);
      return (0, _hyperhtml.default)(_templateObject12(), parentName, linkType, href, escaped);
    }

    const isDefaultJSON = data.type === "operation" && data.name === "toJSON" && data.extAttrs.some(({
      name
    }) => name === "Default");

    if (isDefaultJSON) {
      return (0, _hyperhtml.default)(_templateObject13(), escaped);
    }

    if (!data.partial) {
      const dfn = (0, _hyperhtml.default)(_templateObject14(), linkType, escaped);
      (0, _dfnMap.registerDefinition)(dfn, [name]);
      (0, _dfnFinder.decorateDfn)(dfn, data, parentName, name);
      return dfn;
    }

    const unlinkedAnchor = (0, _hyperhtml.default)(_templateObject15(), data.partial ? "partial" : null, linkType, data.name, linkType, escaped);
    const showWarnings = name && data.type !== "typedef" && !(data.partial && !dfn);

    if (showWarnings) {
      const styledName = data.type === "operation" ? "".concat(name, "()") : name;
      const ofParent = parentName ? " `".concat(parentName, "`'s") : "";
      const msg = "Missing `<dfn>` for".concat(ofParent, " `").concat(styledName, "` ").concat(data.type, ". [More info](https://github.com/w3c/respec/wiki/WebIDL-thing-is-not-defined).");
      (0, _utils.showInlineWarning)(unlinkedAnchor, msg, "");
    }

    return unlinkedAnchor;
  }
  /**
   * Map to Shepherd types, for export.
   * @see https://tabatkins.github.io/bikeshed/#dfn-types
   */


  function getDfnType(idlType) {
    switch (idlType) {
      case "operation":
        return "method";

      case "field":
        return "dict-member";

      case "callback interface":
      case "interface mixin":
        return "interface";

      default:
        return idlType;
    }
  }

  function getIdlDefinitionClassName(defn) {
    switch (defn.type) {
      case "callback interface":
        return "idlInterface";

      case "operation":
        return "idlMethod";

      case "field":
        return "idlMember";

      case "enum-value":
        return "idlEnumItem";

      case "callback function":
        return "idlCallback";
    }

    return "idl".concat(defn.type[0].toUpperCase()).concat(defn.type.slice(1));
  }

  const nameResolverMap = new WeakMap();

  function getNameAndId(defn, parent = "") {
    if (nameResolverMap.has(defn)) {
      return nameResolverMap.get(defn);
    }

    const result = resolveNameAndId(defn, parent);
    nameResolverMap.set(defn, result);
    return result;
  }

  function resolveNameAndId(defn, parent) {
    let name = getDefnName(defn);
    let idlId = getIdlId(name, parent);

    switch (defn.type) {
      // Top-level entities with linkable members.
      case "callback interface":
      case "dictionary":
      case "interface":
      case "interface mixin":
        {
          idlId += resolvePartial(defn);
          break;
        }

      case "constructor":
      case "operation":
        {
          const overload = resolveOverload(name, parent);

          if (overload) {
            name += overload;
            idlId += overload;
          } else if (defn.arguments.length) {
            idlId += defn.arguments.map(arg => "-".concat(arg.name.toLowerCase())).join("");
          }

          break;
        }
    }

    return {
      name,
      idlId
    };
  }

  function resolvePartial(defn) {
    if (!defn.partial) {
      return "";
    }

    if (!idlPartials[defn.name]) {
      idlPartials[defn.name] = 0;
    }

    idlPartials[defn.name] += 1;
    return "-partial-".concat(idlPartials[defn.name]);
  }

  function resolveOverload(name, parentName) {
    const qualifiedName = "".concat(parentName, ".").concat(name);
    const fullyQualifiedName = "".concat(qualifiedName, "()");
    let overload;

    if (!operationNames[fullyQualifiedName]) {
      operationNames[fullyQualifiedName] = 0;
    }

    if (!operationNames[qualifiedName]) {
      operationNames[qualifiedName] = 0;
    } else {
      overload = "!overload-".concat(operationNames[qualifiedName]);
    }

    operationNames[fullyQualifiedName] += 1;
    operationNames[qualifiedName] += 1;
    return overload || "";
  }

  function getIdlId(name, parentName) {
    if (!parentName) {
      return "idl-def-".concat(name.toLowerCase());
    }

    return "idl-def-".concat(parentName.toLowerCase(), "-").concat(name.toLowerCase());
  }

  function getDefnName(defn) {
    switch (defn.type) {
      case "enum-value":
        return defn.value;

      case "operation":
        return defn.name;

      default:
        return defn.name || defn.type;
    }
  }

  function renderWebIDL(idlElement, index) {
    let parse;

    try {
      parse = webidl2.parse(idlElement.textContent, {
        sourceName: String(index)
      });
    } catch (e) {
      (0, _utils.showInlineError)(idlElement, "Failed to parse WebIDL: ".concat(e.bareMessage, "."), e.bareMessage, {
        details: "<pre>".concat(e.context, "</pre>")
      }); // Skip this <pre> and move on to the next one.

      return [];
    }

    idlElement.classList.add("def", "idl");
    const html = webidl2.write(parse, {
      templates
    });

    const render = _hyperhtml.default.bind(idlElement);

    render(_templateObject16(), html);
    idlElement.querySelectorAll("[data-idl]").forEach(elem => {
      if (elem.dataset.dfnFor) {
        return;
      }

      const title = elem.dataset.title; // Select the nearest ancestor element that can contain members.

      const parent = elem.parentElement.closest("[data-idl][data-title]");

      if (parent) {
        elem.dataset.dfnFor = parent.dataset.title;
      }

      (0, _dfnMap.registerDefinition)(elem, [title]);
    }); // cross reference

    const closestCite = idlElement.closest("[data-cite], body");
    const {
      dataset
    } = closestCite;
    if (!dataset.cite) dataset.cite = "WebIDL"; // includes webidl in some form

    if (!/\bwebidl\b/i.test(dataset.cite)) {
      const cites = dataset.cite.trim().split(/\s+/);
      dataset.cite = ["WebIDL", ...cites].join(" ");
    }

    return parse;
  }

  function run() {
    const idls = document.querySelectorAll("pre.idl");

    if (!idls.length) {
      return;
    }

    if (!document.querySelector(".idl:not(pre)")) {
      const link = document.querySelector("head link");

      if (link) {
        const style = document.createElement("style");
        style.textContent = _webidl2.default;
        link.before(style);
      }
    }

    const astArray = [...idls].map(renderWebIDL);
    const validations = webidl2.validate(astArray);

    for (const validation of validations) {
      let details = "<pre>".concat(validation.context, "</pre>");

      if (validation.autofix) {
        validation.autofix();
        details += "Try fixing as:\n      <pre>".concat(webidl2.write(astArray[validation.sourceName]), "</pre>");
      }

      (0, _utils.showInlineError)(idls[validation.sourceName], "WebIDL validation error: ".concat(validation.bareMessage), validation.bareMessage, {
        details
      });
    }

    document.normalize();
  }
});
//# sourceMappingURL=webidl.js.map